import React from "react";
import { Box, Typography, IconButton, useTheme, useMediaQuery } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

const Header: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      {/* Menu Section */}
      <Box
        sx={{
          position: "relative",
          top: 0,
          left: 0,
          width: "100%",
          backgroundColor: "#8BC34A",
          padding: {
            xs: "8px 8px", // Mobile padding
            sm: "8px 16px", // Small tablet padding
            md: "8px 16px", // Desktop padding
          },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#fff",
          zIndex: 4,
          boxSizing: "border-box",
          height: {
            xs: "auto", // Auto height on mobile
            md: "50px", // Fixed height on desktop
          },
          minHeight: "50px",
          flexWrap: {
            xs: "wrap", // Allow wrapping on mobile
            md: "nowrap", // No wrapping on desktop
          }
        }}
      >
        <Box sx={{ 
          paddingLeft: {
            xs: "0px", // No padding on mobile
            sm: "20px", // Small padding on tablet
            md: "100px", // Full padding on desktop
          },
          display: "flex", 
          alignItems: "center", 
          gap: {
            xs: "8px", // Smaller gap on mobile
            md: "16px", // Full gap on desktop
          },
          flexWrap: "wrap",
          flex: 1,
        }}>
          {!isSmallMobile && (
            <Box
              sx={{
                width: "1px",
                height: "50px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                display: { xs: "none", md: "block" },
              }}
            />
          )}
          <Typography
            variant="body2"
            sx={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: {
                xs: "12px", // Smaller font on mobile
                md: "14px", // Normal font on desktop
              },
              color: "#fff",
              whiteSpace: "nowrap",
            }}
          >
            {isSmallMobile ? "📧 getmyshares1@gmail.com" : "getmyshares1@gmail.com"}
          </Typography>
          {!isMobile && (
            <Box
              sx={{
                width: "1px",
                height: "50px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
              }}
            />
          )}
         
          <Typography
            variant="body2"
            sx={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: {
                xs: "12px", // Smaller font on mobile
                md: "14px", // Normal font on desktop
              },
              color: "#fff",
              whiteSpace: "nowrap",
            }}
          >
            📞 9318469513
          </Typography>
          {!isMobile && (
            <Box
              sx={{
                width: "1px",
                height: "50px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
              }}
            />
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: {
              xs: "8px", // Smaller gap on mobile
              md: "12px", // Full gap on desktop
            },
            paddingRight: {
              xs: "0px", // No padding on mobile
              sm: "20px", // Small padding on tablet
              md: "100px", // Full padding on desktop
            },
          }}
        >
          <IconButton
            color="inherit"
            size={isMobile ? "small" : "medium"}
            sx={{
              color: "#fff",
              padding: {
                xs: "4px", // Smaller padding on mobile
                md: "8px", // Normal padding on desktop
              },
            }}
          >
            <FacebookIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
          {!isMobile && (
            <Box
              sx={{
                width: "1px",
                height: "50px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
              }}
            />
          )}
          <a 
            href="https://www.linkedin.com/company/getmyshares-com/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <IconButton
              color="inherit"
              size={isMobile ? "small" : "medium"}
              sx={{
                color: "#fff",
                padding: {
                  xs: "4px", // Smaller padding on mobile
                  md: "8px", // Normal padding on desktop
                },
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
                "&:focus": {
                  outline: "none",
                },
              }}
            >
              <LinkedInIcon fontSize={isMobile ? "small" : "medium"} />
            </IconButton>
          </a>
          {!isMobile && (
            <Box
              sx={{
                width: "1px",
                height: "50px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
              }}
            />
          )}
          <IconButton
            color="inherit"
            size={isMobile ? "small" : "medium"}
            sx={{
              color: "#fff",
              padding: {
                xs: "4px", // Smaller padding on mobile
                md: "8px", // Normal padding on desktop
              },
            }}
          >
            <InstagramIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
          {!isMobile && (
            <Box
              sx={{
                width: "1px",
                height: "50px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
